import { msg } from '@lingui/core/macro';
import { commonPlaceholder } from 'modules/overlay-canvas/types/placeholders/create-argument';
import type { MessageDescriptor } from 'shared/i18n/i18n';

interface IItem extends commonPlaceholder {
  /** Подпись кнопки в меню. `blockText` — текст объекта на канве, он сохраняется в табло и не переводится. */
  listName: MessageDescriptor;
}

export const complexPlaceholdersList: IItem[] = [
  {
    listName: msg`Последние результаты команды`,
    indicator: 'lastGameResults',
    blockText: 'Последние результаты\nкоманды',
    type: 'image',
    teamIndex: 0,
  },
  {
    blockText: 'Состав команды',
    indicator: 'teamComposition',
    listName: msg`Состав команды`,
    type: 'composition',
    teamIndex: 0,
  },
  {
    blockText: 'Фолы команды в тайме',
    indicator: 'teamPeriodFouls',
    listName: msg`Фолы команды в тайме`,
    type: 'composition',
    teamIndex: 0,
  },
  {
    blockText: 'Серия пенальти',
    indicator: 'teamShootoutSeries',
    listName: msg`Серия пенальти`,
    type: 'composition',
    teamIndex: 0,
  },
];
